import { Tooltip, TooltipContent, TooltipTrigger } from 'cpool-components/general/Tooltip';
import type { OFFER_DOCUMENT_UPLOAD_STATUS } from 'cpool-constants';
import { OFFER_DOCUMENT_UPLOAD_STATUSES } from 'cpool-constants';
import { LuCircleCheck, LuCircleMinus, LuCircleX } from 'react-icons/lu';

import useLead from '~/features/leadDetails/hooks/useLead';
import type { SchemaRecordedDocumentListEntry } from '~/features/leadDetails/schemas/recordedDocuments.schema';

type Props = {
    documentKey: string;
    leadId: string;
    uploadedTo: SchemaRecordedDocumentListEntry['uploadedTo'];
};

const statusIcon = (uploadStatus: OFFER_DOCUMENT_UPLOAD_STATUS | null | undefined) => {
    if (!uploadStatus || uploadStatus === OFFER_DOCUMENT_UPLOAD_STATUSES.PENDING)
        return <LuCircleMinus className="text-midnight-placeholder" size={16} />;
    if (uploadStatus === OFFER_DOCUMENT_UPLOAD_STATUSES.SUCCESS)
        return <LuCircleCheck className="text-status-green-text" size={16} />;
    return <LuCircleX className="text-status-red-text" size={16} />;
};

// Brand name of the external platform — not translated.
const PLATFORM_LABEL = 'Europace';

export const UploadStatusCell: React.FC<Props> = ({ documentKey, leadId, uploadedTo }) => {
    const { data: lead } = useLead(leadId);
    const platform = lead?.europace?.platform;
    const uploadStatus = platform ? uploadedTo?.europacePlatform?.[platform]?.uploadStatus : undefined;

    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <span className="inline-flex" data-testid={`upload-status-icon-${PLATFORM_LABEL}-${documentKey}`}>
                    {statusIcon(uploadStatus)}
                </span>
            </TooltipTrigger>
            <TooltipContent>{PLATFORM_LABEL}</TooltipContent>
        </Tooltip>
    );
};
